import { useEffect, useState } from "react";
import { api, photoUrl } from "@/lib/api";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Bende() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    api.get("/bende").then((r) => setMembers(r.data));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 py-20" data-testid="bende-page">
      <div className="text-center mb-14">
        <p className="text-[11px] tracking-[0.3em] uppercase text-[#006A71]">La nostra banda</p>
        <h1 className="font-script text-6xl sm:text-7xl text-[#006A71] mt-3">De Bende</h1>
        <div className="section-divider"><span className="section-divider-dot" /></div>
      </div>

      <div className="mb-16 relative">
        <img
          src="/assets/bende.png"
          alt="De bende, met kinderen en al"
          className="w-full max-h-[560px] object-cover object-top rounded-sm brutal-shadow-lg"
          data-testid="bende-hero-image"
        />
      </div>

      <div className="text-center mb-16">
        <p className="font-serif italic text-[#4A6165] max-w-xl mx-auto">
          Een woordje van elk koppel uit de vriendengroep. Klik op een kaartje om hun boodschap te lezen.
        </p>
      </div>

      <div className="relative">
        <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-px bg-[#006A71]/30 hidden md:block" />
        <div className="space-y-20">
          {members.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={`md:grid md:grid-cols-2 md:gap-16 items-center ${i % 2 === 0 ? "" : "md:[direction:rtl]"}`}
            >
              <div className={`relative ${i % 2 === 0 ? "text-left md:text-right" : "text-right md:text-left md:[direction:ltr]"}`}>
                <NavLink to={`/de-bende/${m.slug}`} data-testid={`bende-card-${m.slug}`}>
                  <div className="polaroid inline-block max-w-md relative">
                    {m.cover_photo_id ? (
                      <img src={photoUrl(m.cover_photo_id)} alt={m.names} className={`w-full h-64 object-cover ${!m.unlocked ? "grayscale opacity-60" : ""}`} />
                    ) : (
                      <div className="w-full h-64 bg-[#E8DFCF] flex items-center justify-center">
                        <span className={`font-script text-5xl text-[#006A71] ${!m.unlocked ? "opacity-50" : ""}`}>{m.names.split(" ")[0]}</span>
                      </div>
                    )}
                    {!m.unlocked && (
                      <div className="absolute top-3 left-3 bg-[#FAF6EF]/95 border border-[#006A71]/30 px-2 py-1 text-[9px] tracking-[0.28em] uppercase text-[#006A71]">
                        Binnenkort
                      </div>
                    )}
                  </div>
                </NavLink>
              </div>
              <div className={`mt-8 md:mt-0 ${i % 2 === 0 ? "text-left" : "text-right md:[direction:ltr]"}`}>
                <p className="text-[11px] tracking-[0.3em] uppercase text-[#006A71]">
                  Capitolo {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="font-script text-5xl text-[#006A71] mt-2">{m.names}</h3>
                {m.tagline && m.unlocked && <p className="font-serif italic text-lg text-[#4A6165] mt-3">{m.tagline}</p>}
                <NavLink
                  to={`/de-bende/${m.slug}`}
                  className="btn-ghost inline-flex items-center gap-2 mt-6"
                  data-testid={`bende-cta-${m.slug}`}
                >
                  {m.unlocked ? (
                    <>Lees de boodschap <ArrowRight className="w-3.5 h-3.5" /></>
                  ) : (
                    <>Binnenkort onthuld</>
                  )}
                </NavLink>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
